"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isError = (state = {
    error: false,
    message: '',
}, action) => {
    if (action.type === 'DISMISS_FAILURE') {
        return {
            error: false,
            message: '',
        };
    }
    if (action.type.includes('FAILURE')) {
        return {
            error: true,
            message: action.message,
        };
    }
    return state;
};
exports.getIsError = (state) => state;
exports.default = isError;
